module.exports = __webpack_public_path__ + "static/pbp-513fb1088e2ba190f92873661b6669cd.gif";